import React from "react";
import { Tabs } from "antd";
import {
  BarChartOutlined,
  ClockCircleOutlined,
  FileTextOutlined,
} from "@ant-design/icons";
import SummaryEmployeeList from "../components/summary/SummaryEmployeeList";
import MyPaidOvertime from "../components/MyPaidOvertime";
import ReportTab from "../components/summary/ReportTab";
import { useTranslation } from "react-i18next";

const SummaryPage = () => {
  const { t } = useTranslation();

  return (
    <div>
      <Tabs
        defaultActiveKey="summary"
        destroyInactiveTabPane
        items={[
          {
            key: "summary",
            label: (
              <span>
                <BarChartOutlined style={{ marginRight: 8 }} />
                {t("summary")}
              </span>
            ),
            children: <SummaryEmployeeList />,
          },
          {
            key: "myPaidOvertime",
            label: (
              <span>
                <ClockCircleOutlined style={{ marginRight: 8 }} />
                {t("paidOvertime.myPaidOvertime")}
              </span>
            ),
            children: <MyPaidOvertime />,
          },
          {
            key: "report",
            label: (
              <span>
                <FileTextOutlined style={{ marginRight: 8 }} />
                {t("report.tab")}
              </span>
            ),
            children: <ReportTab />,
          },
        ]}
      />
    </div>
  );
};

export default SummaryPage;
